<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         class="ui-processes-page-grid ">

    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button [matTooltip]="'grid_action_add' | translate"
                        [uiAuthorizeAllDisable]="['Processes.Create', 'Packages.View', 'Environments.View']"
                        [uiClickTrack]="'Action: Add Proccess'"
                        (click)="openModal()"
                        mat-mini-fab
                        color="primary"
                        data-cy="process-create"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorize]="'Processes.Delete'"
                        [disableIf]="loading$ | async"
                        [matTooltip]="'processes_grid_remove_tooltip' | translate"
                        (click)="removeProcesses()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                </button>
                <button [uiAuthorizeAllDisable]="['Processes.Edit', 'Processes.View', 'Packages.View']"
                        [disableIf]="(loading$ | async) ||
                                    !isEveryProcessOutOfDate"
                        [matTooltip]="'processes_grid_bulk_update_tooltip' | translate"
                        (click)="onBulkUpdateItems()"
                        mat-icon-button
                        type="button">
                    <mat-icon>file_upload</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [visible]="false"
                    [sortable]="true"
                    property="name"
                    sort="asc">
    </ui-grid-column>

    <ui-grid-column [title]="'processes_grid_name' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    property="processKey"
                    width="20%">
        <ng-template let-entry="data">
            <mat-icon *ngIf="!entry.isLatestVersion && !entry.isProcessDeleted"
                      [title]="'process_update_available_warning' | translate"
                      class="grid-icon"
                      svgIcon="uipath:StatusUpdate"
                      color="primary">
            </mat-icon>
            <mat-icon *ngIf="entry.isProcessDeleted"
                      [title]="'processes_versions_process_deleted_warning' | translate"
                      class="grid-icon"
                      svgIcon="uipath:StatusWarning">
            </mat-icon>
            <mat-icon *ngIf="entry.isLatestVersion && !entry.isProcessDeleted"
                      class="grid-icon"
                      svgIcon="uipath:StatusOK"
                      color="success">
            </mat-icon>
            <span [matTooltip]="entry.processKey">{{ entry.processKey }}</span>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'processes_grid_version' | translate"
                    property="processVersion"
                    width="20%">
    </ui-grid-column>

    <ui-grid-column *ngIf="isCurrentFolderClassic$ | async"
                    [title]="'processes_grid_environment' | translate"
                    [searchable]="true"
                    [sortable]="true"
                    [primary]="true"
                    property="environment.name"
                    width="20%">
    </ui-grid-column>

    <ui-grid-column [title]="'processes_grid_description' | translate"
                    property="description"
                    [searchable]="true"
                    width="40%">
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matTooltip]="'global_more_actions_tooltip' | translate"
                    [matMenuTriggerFor]="menu"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiAuthorize]="'Packages.View'"
                        [disabled]="loading.processDetails$ | async"
                        [uiClickTrack]="'Action: Grid: View Versions'"
                        (click)="openVersionsModal(entry)"
                        mat-menu-item
                        data-cy="process-version-management"
                        type="button">
                    <mat-icon>notes</mat-icon>
                    {{ 'processes_grid_view_versions_tooltip' | translate }}
                </button>
                <button *ngIf="isCurrentFolderClassic$ | async"
                        [uiAuthorizeAllDisable]="['Schedules.View', 'Schedules.Create']"
                        [uiClickTrack]="'Action: Grid: Add Time Trigger'"
                        [routerLink]="['/triggers','add']"
                        [queryParams]="getProcessTriggerParams(entry)"
                        mat-menu-item
                        data-cy="queue-add-trigger"
                        type="button">
                    <mat-icon svgIcon="uipath:triggers"></mat-icon>
                    {{ 'processes_grid_add_trigger' | translate }}
                </button>
                <button [disableIf]="!isMonitoringEnabled"
                        [routerLink]="['/monitoring/jobs/', entry.id]"
                        [uiAuthorizeAll]="['Monitoring.View', 'Jobs.View']"
                        [uiClickTrack]="'Action: Grid: Monitor Process'"
                        mat-menu-item
                        data-cy="process-monitor"
                        type="button">
                    <mat-icon>insert_chart</mat-icon>
                    {{ 'processes_grid_action_monitor' | translate }}
                </button>
                <button *ngIf="isProcessSettingEnabled"
                        [disableIf]="loading.processDetails$ | async"
                        [uiAuthorize]="'Processes.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit Recording Settings'"
                        (click)="openProcessSettingsModal(entry)"
                        mat-menu-item
                        data-cy="process-recording-management"
                        type="button">
                    <mat-icon>build</mat-icon>
                    {{ 'processes_grid_edit_process_settings' | translate }}
                </button>
                <button [uiAuthorize]="'Processes.Delete'"
                        [disableIf]="loading$ | async"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeProcesses([entry])"
                        mat-menu-item
                        color="warn"
                        data-cy="process-delete"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    {{ 'processes_grid_remove_tooltip' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
